<template>
    <div class="px-2">
        <v-toolbar flat>
            <v-toolbar-title><b>Theory Notes</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div>
            <v-row>
                <v-list-item v-for="(item, i) in cards" :key="i">
                    <v-card-text class="custom-bg_locfeed">
                        <v-row>
                            <v-col cols="6">
                                <v-textarea
                                    v-model="item.text"
                                    name="input-7-1"
                                    auto-grow
                                    value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                                ></v-textarea>
                            </v-col>
                            <v-col cols="4">
                                <v-img
                                    :src="item.url"
                                    max-height="134"
                                    min-height="134"
                                    max-width="134"
                                    min-width="134"
                                    v-model="profilePicture"
                                    contain
                                    bordered
                                    elevation
                                ></v-img>
                            </v-col>
                            <v-col cols="2">
                                <v-file-input
                                    accept="image/png,image/jpeg,image/bmp"
                                    prepend-icon="mdi-pencil-outline"
                                    label="profilePicture"
                                    ref="file"
                                    hide-input
                                    dense
                                    @change="onFileSelected(i)"
                                >
                                </v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-row>
                        <v-col cols="8">
                            <v-btn v-on:click="deleteNote(i)">
                                Delete
                            </v-btn>
                            <v-btn v-on:click="addtNote(i)">
                                Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-row>
            <v-row>
                <v-col cols="10"> </v-col>

                <v-col cols="1">
                    <v-btn v-on:click="more()">
                        more
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import url1 from "../../../config.js";

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) {
                    vm.$router.push("/");
                }
            }, 0);
        });
    },
    name: "TermsAndCondition",
    data() {
        return {
            textTermsAndCondtions: "",
            url: url1.url,
            cards: [{ id: "", text: "", url: "" }],
            profilePicture: [],
            file: []
        };
    },

    methods: {
        getNotes() {
            axios
             
                .get(this.url+'/api/notes/')
                .then(res => {
                    console.log(res.data.NotesList);
                    this.cards = res.data.NotesList;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        onFileSelected(i) {
            console.log("picture onfileselected");
            console.log(event.target.files[0]);

            if (event.target.files[0]) {
                this.file[i] = event.target.files[0];

                this.cards[i].url = URL.createObjectURL(event.target.files[0]);
                console.log(this.profilePicture);
                console.log(i);
            }
        },
        saveData(i) {
            const formData = new FormData();
            formData.append("fileImage", this.file[i]);
            formData.append("text", this.cards[i.text]);
            console.log(formData);
            axios
                .post(this.url+'/api/notes/', formData)
                .then(res => {
                    console.log(res);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        addtNote(i) {
            console.log(this.cards[i].text);
            console.log(this.cards[i].id);
            const formData = new FormData();
            formData.append("fileImage", this.file[i]);
            formData.append("text", this.cards[i].text);
            formData.append("id", this.cards[i].id);
            console.log(formData);
            if (this.cards[i].id) {
                axios
                    .put(this.url+"/api/notes/", formData)
                    .then(res => {
                        console.log(res);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            } else {
                axios
                    .post(this.url+'/api/notes/', formData)
                    .then(res => {
                        console.log(res);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        deleteNote(i) {
            console.log(i);
            // this.cards.splice(i, 1);
            axios
                .delete(
                    this.url+'/api/notes/' + this.cards[i].id
                )
                .then(res => {
                    console.log(res);
                    this.getNotes();
                })
                .catch(err => {
                    console.log(err);
                });
        },
        more() {
            console.log(this.cards.length);

            this.cards.push({ id: null, text: "text", url: "" });
            console.log(this.cards);
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    mounted() {
        this.getNotes();
    }
};
</script>

<style scoped>
.theme--light.v-card {
    background: white;
    border: 0;
}
.custom-bg_locfeed {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
</style>
